var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncident(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 87,
    viewBox: "0 0 97 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.906 7.31442C44.2056 -1.76354 52.789 -1.7794 58.0973 7.31442L94.7252 70.0608C100.025 79.1387 95.7465 86.5 85.1942 86.5H11.8119C1.24826 86.5 -3.02799 79.1546 2.28089 70.0608L38.906 7.31442ZM42.1208 33.7347V54.3036C42.1208 56.052 43.5625 57.5038 45.3402 57.5038H51.6589C53.4655 57.5038 54.8782 56.0697 54.8782 54.3036V33.7347C54.8782 31.9842 53.4366 30.5346 51.6589 30.5346H45.3402C43.5336 30.5346 42.1208 31.9664 42.1208 33.7347ZM42.1208 65.4643V71.7496C42.1208 73.5467 43.5625 74.952 45.3402 74.952H51.6589C53.4655 74.952 54.8782 73.5201 54.8782 71.7496V65.4643C54.8782 63.6694 53.4366 62.2619 51.6589 62.2619H45.3402C43.5336 62.2619 42.1208 63.696 42.1208 65.4643Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncident);
export default __webpack_public_path__ + "static/media/Incident.3b3449f42cfa3b7f95355c1eb2932163.svg";
export { ForwardRef as ReactComponent };